import React from 'react';
import { Alert, Box, Button, Spinner } from '@amzn/awsui-components-console';
export function ErrorGoToHomepage() {
  return (
    <Box padding='xl'>
      <Spinner size='large' />
    </Box>
  );
}
